import React from 'react';
import CredentialSummaryCard from './CredentialSummaryCard';
import { v4 } from 'node-uuid';
import {CREDENTIAL_TYPES} from '../../constants';
import { getCredCount } from '../../utils';

const CredentialsSummary = (props) => {
  const summary = props.credentials.summary;

  return (
    <div>
      {CREDENTIAL_TYPES.map((type) =>
        <CredentialSummaryCard
          key={v4()}
          type={type}
          incomplete={getCredCount(summary, type, 'incomplete')}
          total={getCredCount(summary, type, 'total')}
        />
      )}
    </div>
  );
};

export default CredentialsSummary;



// WEBPACK FOOTER //
// ./src/components/Credentials/CredentialsSummary.js